<template>
  <div class="f-e" style="width:100%">
    <div class="f--c search" :style="{ border: inputFocus ? '1px solid #9AC331' : 'unset' }">
      <el-popover v-model="visible" placement="bottom" :width="480" trigger="manual" popper-class="search-popper" class="popper">
        <div style="width:100%" slot="reference">
          <el-input v-model="input" :placeholder="$t('inSrock.search')" clearable @input="handleInput" @keyup.enter.native="handleSearch()" @focus="handleInputFocus" @blur="handleInputBlur" />
        </div>
        <div v-if="input && recommendList.length" class="search-popper-box">
          <div v-for="t in recommendList" :key="t" class="recommend-item" @click="handleSearch(t)">{{ t }}</div>
        </div>
        <div v-if="!input" class="search-popper-box">
          <template v-if="recentSearches.length">
            <div class="title">{{ $t('inSrock.recentSearches') }}</div>
            <div class="item-list">
              <div v-for="item in recentSearches" :key="item" class="item f-c-c" @click="handleSearch(item)">{{ item }}</div>
            </div>
          </template>
          <template v-if="hotSearches.length">
            <div class="title">
              <icon-park type="Fire" theme="filled" size="16" fill="#F36D6F" />
              {{ $t('inSrock.hotSearches') }}
            </div>
            <div class="item-list">
              <div v-for="item in hotSearches" :key="item" class="item f-c-c" @click="handleSearch(item)">{{ item }}</div>
            </div>
          </template>
        </div>
      </el-popover>
      <div  @click="drawerSimilar = true">
        <icon-park type="viewfinder" theme="filled" size="20" class="pointer" style="position: relative;top:2px"/>
      </div>
      <el-button class="search-btn" icon="el-icon-search" type="primary" @click="handleSearch()" />
    </div>
    <div class="icon-list f--c">
      <div class="item f-c-c pointer icon_search" @click="openDrawerSearch">
        <!-- <img src="/img/icon/icon_search.png" alt=""> -->
        <i class="el-icon-search" style="font-weight:600;font-size:18px"></i>
      </div>
    </div>
    <el-drawer :visible.sync="drawerSearch" direction="ttb" :with-header="false" :lock-scroll="true" :append-to-body="true" size="60%" custom-class="drawer-search-mobile">
      <div class="drawer-head f--c">
        <icon-park type="Left" theme="outline" size="36" fill="#333" @click="drawerSearch = false" />
        <div class="search-border f--c" :style="{ border: inputFocus ? '1px solid #9AC331' : 'unset' }">
          <el-input v-model="input" :placeholder="$t('inSrock.search')" clearable @input="handleInput" @keyup.enter.native="handleSearch()" @focus="inputFocus=true" @blur="inputFocus=false" />
          <div @click="drawerSimilar = true">
            <icon-park type="Viewfinder" theme="filled" size="20" fill="#333" class="pointer" />
          </div>
        </div>
        <el-button class="search-btn" icon="el-icon-search" type="primary" @click="handleSearch()" />
      </div>
      <div v-if="input" class="drawer-search-content">
        <div v-for="t in recommendList" :key="t" class="recommend-item" @click="handleSearch(t)">{{ t }}</div>
      </div>
      <div v-else class="drawer-search-content">
        <template v-if="recentSearches.length">
          <div class="title">{{ $t('inSrock.recentSearches') }}</div>
          <div class="item-list">
            <div v-for="item in recentSearches" :key="item" class="item f-c-c" @click="handleSearch(item)">{{ item }}</div>
          </div>
        </template>
        <template v-if="hotSearches.length">
          <div class="title" style="margin-top:12px">
            <icon-park type="Fire" theme="filled" size="16" fill="#F36D6F" />
            {{ $t('inSrock.hotSearches') }}
          </div>
          <div class="item-list">
            <div v-for="item in hotSearches" :key="item" class="item f-c-c" @click="handleSearch(item)">{{ item }}</div>
          </div>
        </template>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="drawerSimilar" :title="$t('Index.Components.UploadPopout.VisualSearch')" direction="rtl" :append-to-body="true" size="50%" custom-class="drawer-drawerSimilar">
      <div class="drawer-drawerSimilar-content f--c">
        <oss-img src="https://img.kakaclo.com/web-img/index/image_recognition.png" :width="96" :height="136" />
        <div class="text">{{$t('Index.Components.UploadPopout.Max5MBPerImage')}}</div>
          <photograph @beforeUpload="loading = true" @uploadSuccess="uploadSuccess">
            <el-button :loading="loading" type="primary" size="large" style="padding:12px 50px;">{{$t('Index.Components.UploadPopout.UploadImage')}}</el-button>
          </photograph>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import { Viewfinder, Fire, Left } from '@icon-park/vue'
import { IconPark } from '@icon-park/vue/es/all'
import API from '@/api'
import Photograph from '@/views/index/components/Photograph.vue'
export default {
  components: { Photograph, IconPark },
  data() {
    return {
      visible: false,
      input: '',
      loading: false,
      recentSearches: [],
      hotSearches: [],
      recommendList: [],
      drawerSearch: false,
      drawerSimilar: false,
      inputFocus: false
    }
  },
  mounted() {
    this.getSearches()
  },
  methods: {
    getSearches() {
      API.getSearches({ userId: this.$store.state.common.userId }).then(result => {
        this.recentSearches = result.data.userHotTermsList
        this.hotSearches = result.data.globalHotTermsList
      })
    },
    suggestionCompletion() {
      let form = { text: this.input }
      API.suggestionCompletion(form).then(res => {
        this.recommendList = res.data
        if (this.input && !this.recommendList.length) {
          this.visible = false
        } else if (this.input && !this.drawerSearch) {
          this.visible = true
        }
      })
    },
    handleInput() {
      this.suggestionCompletion()
    },
    handleSearch(item) {
      if (item) {
        this.input = item
      }
      this.visible = false
      this.drawerSearch = false
      let path = `/product-list${this.input ? '?search=' + this.input : ''}`
      location.href = path
    },
    openDrawerSearch() {
      this.drawerSearch = true
      this.getSearches()
    },
    uploadSuccess() {
      this.loading = false
      this.drawerSimilar = false
    },

    handleInputFocus() {
      this.inputFocus = true
      this.visible = true
    },
    handleInputBlur() {
      this.inputFocus = false
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  max-width: 480px;
  width: 100%;
  height: 40px;
  // border: 1px solid #E1E4EA;
  background-color: #F7F8FB;
  box-sizing: border-box;
  padding-left: 6px;
  font-size: 12px;
  margin-right: 16px;
  .popper {
    display: block;
    width: 100%;
  }
  /deep/ .el-input__inner {
    box-shadow: unset;
    border: unset;
    font-size: 12px;
    padding: 0 8px;
    background-color: #F7F8FB;
  }
  img {
    display: block;
    width: 20px;
    height: 20px;
  }
  .search-btn {
    width: 40px;
    height: 40px;
    background-color: #9AC331;
    border-radius: 0;
    margin-left: 10px;
    padding: 0;
    flex-shrink: 0;
    /deep/ .el-icon-search {
      font-size: 20px;
    }

  }
}
.icon-list {
  font-size: #333;
  margin-left: 16px;
  display: none;
  .item {
    width: 40px;
    height: 40px;
    margin-left: 8px;
    border-radius: 50%;
    transition: background-color .3s cubic-bezier(.645,.045,.355,1);
    > img {
      width: 20px;
      height: 20px;
    }
  }
  .item:hover {
    background-color: #efefef;
  }
}

// .search-popper {
//   .recommend-item {
//     height: 30px;
//     line-height: 30px;
//     cursor: pointer;
//     &:hover {
//       background-color: #F7F8FB;
//     }
//   }
//   .title {
//     color: #303133;
//     font-size: 16px;
//     margin-bottom: 12px;
//   }
//   .item-list {
//     display: flex;
//     flex-wrap: wrap;
//     .item {
//       color: #606266;
//       height: 28px;
//       line-height: 28px;
//       padding: 0 12px;
//       border-radius: 2px;
//       background-color: #F7F8FB;
//       margin-right: 8px;
//       margin-bottom: 12px;
//       font-size: 14px;
//       cursor: pointer;
//     }
//   }
// }
@media screen and (max-width: 1000px) {
  .search {
    display: none;
  }
  .icon-list {
    display: block;
    margin-left: 0;
  }
}
</style>

<style lang="scss">
.search-popper {
  padding: 0 !important;
}
.search-popper-box {
  padding: 16px;
  .recommend-item {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    &:hover {
      background-color: #F7F8FB;
    }
  }
  .title {
    color: #303133;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .item-list {
    display: flex;
    flex-wrap: wrap;
    .item {
      color: #606266;
      height: 28px;
      line-height: 28px;
      padding: 0 12px;
      border-radius: 2px;
      background-color: #F7F8FB;
      margin-right: 8px;
      margin-bottom: 12px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.drawer-search-mobile {
  .el-drawer__body {
    padding: 16px;
  }
  .drawer-head {
    height: 40px;
    margin-bottom: 16px;
    .search-border {
      flex: 1;
      height: 100%;
      background-color: #F7F8FB;
      padding: 0 12px 0 4px;
      .el-input__inner {
        box-shadow: unset;
        border: unset;
        font-size: 12px;
        padding: 0 8px;
        background-color: #F7F8FB;
      }
    }
    // .btn-img {
    //   width: 20px;
    //   height: 20px;
    // }
    .search-btn {
      width: 40px;
      height: 40px;
      background-color: #9AC331;
      border-radius: 0;
      padding: 0;
      flex-shrink: 0;
      .el-icon-search {
        font-size: 20px;
      }
    }
  }
  .drawer-search-content {
    .recommend-item {
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      &:hover {
        background-color: #F7F8FB;
      }
    }
    .title {
      color: #303133;
      font-size: 16px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .item-list {
      display: flex;
      flex-wrap: wrap;
      .item {
        color: #606266;
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        border-radius: 2px;
        background-color: #F7F8FB;
        margin-right: 8px;
        margin-bottom: 12px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}
.drawer-drawerSimilar {
  min-width: 460px;
  max-width: 751px;
  .el-drawer__body {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .drawer-drawerSimilar-content{
    flex-direction: column;
    color: #909399;
    position: relative;
    top: -5%;
    >img {
      width: 180px;
    }
    .text {
      margin: 30px 0;
    }
  }
}

@media screen and (max-width: 1000px) {
  // .drawer-search-mobile {
  //   display: none;
  // }
  // .drawer-drawerSimilar-mobile {
  //   display: none;
  // }
  .drawer-drawerSimilar {
    top: unset !important;
    bottom: 0 !important;
    width: 100% !important;
    min-width: unset !important;
    height: 55% !important;
    min-height: 480px;
    .drawer-drawerSimilar-content{
      >img {
        width: 130px;
      }
      .text {
        margin: 16px 0;
      }
    }
  }
}
</style>
